export function computeItemsFilteredByAllergens(
  stationOptions,
  selectedAllergies = [],
) {
  const allergies = Array.isArray(selectedAllergies)
    ? selectedAllergies
    : selectedAllergies
      ? [selectedAllergies]
      : [];

  const normalized = new Set(
    allergies.map((a) => String(a).trim()).filter((s) => s !== ""),
  );

  if (normalized.has("none")) normalized.clear();

  const activeGroups = (stationOptions || []).filter((opt) => {
    const nonDeletedItems = (opt.items || []).filter(
      (item) => item && item.isDeleted !== 1,
    );
    return nonDeletedItems.some(
      (item) => item.visible === 1 || item.visible === true,
    );
  });

  const filteredOptions = activeGroups.map((opt) => {
    const items = (opt.items || []).filter((item) => {
      if (!item) return false;
      if (item.isDeleted === 1) return false;
      if (item.visible !== undefined && item.visible !== 1) return false;

      if (normalized.size === 0) return true;

      const itemAllergens = Array.isArray(item.allergens) ? item.allergens : [];
      const itemAllergenSet = new Set(itemAllergens.map((x) => String(x)));

      for (const a of normalized) {
        if (itemAllergenSet.has(a)) return false;
      }

      return true;
    });

    return { ...opt, items };
  });

  const allowedItemIds = new Set();
  filteredOptions.forEach((opt) => {
    (opt.items || []).forEach((it) => allowedItemIds.add(String(it.id)));
  });

  return { filteredOptions, allowedItemIds };
}

export function computeSelectedByGroup(
  stationOptions,
  formValues = {},
  allowedItemIds = null,
) {
  const selectedByGroup = {};
  (stationOptions || []).forEach((opt) => {
    const group = opt.group || {};
    const rawId = group.id ?? group.group_id ?? group._id ?? null;
    const groupId = rawId != null ? Number(rawId) : null;
    const fieldName = `menu_option-${group.group_name}`;
    const val = formValues[fieldName];
    if (val === undefined || val === null) return;
    const items = Array.isArray(val) ? val : [val];
    if (items.length === 0) return;

    const filteredItems = allowedItemIds
      ? items.filter((it) => allowedItemIds.has(String(it)))
      : items;

    if (filteredItems.length === 0) return;
    if (groupId) selectedByGroup[groupId] = filteredItems;
  });
  return selectedByGroup;
}

export function computeFilteredGroupIds(stationOptions, selectedByGroup = {}) {
  const visible = (stationOptions || [])
    .map((opt) => {
      const g = opt.group || {};
      const rawId = g.id ?? g.group_id ?? g._id ?? null;
      const gid = rawId != null ? Number(rawId) : null;
      const sc = g.show_condition || null;

      if (!sc || !sc.otherGroupId) {
        return gid;
      }

      const otherId = Number(sc.otherGroupId);
      const requiredItemIds = Array.isArray(sc.itemIds) ? sc.itemIds : [];

      const selected = selectedByGroup[otherId] || [];
      if (!selected || selected.length === 0) return null;

      if (requiredItemIds.length === 0) {
        return gid;
      }

      const selectedSet = new Set(selected.map((s) => String(s)));
      const has = requiredItemIds.some((rid) => selectedSet.has(String(rid)));
      return has ? gid : null;
    })
    .filter((v) => v != null);

  return visible.length ? visible : null;
}

/**
 * Returns true when disabling the given item would leave no visible,
 * non-deleted items in the group — meaning the group should be
 * automatically disabled too.
 */
export function shouldAutoDisableGroup(groupItems, excludeItemId) {
  return groupItems
    .filter((i) => i.id !== excludeItemId && !i.isDeleted)
    .every((i) => !i.visible);
}
